export default __webpack_public_path__ + "static/media/logotext.386c8b95.png";